export default "__VITE_ASSET__8V6g8LwN__ 640w, __VITE_ASSET__CetKSmAo__ 1024w, __VITE_ASSET__D_PeZQto__ 1920w";